/* global LOCAL_PRODUCT_ID */
;(function () {
  'use strict'

  const isLoggedIn = localStorage.getItem('awLogin') === 'true'
  const darkMode = localStorage.getItem('awDarkMode') || 'auto'
  const darkModeVariant = localStorage.getItem('awDarkModeVariant') || ''
  const menuPinned = localStorage.getItem('awMenu') === 'true'
  const menuWidth = localStorage.getItem('awMenuWidth') || '280'
  const menuCompact = localStorage.getItem('awMenuCompact') === 'true'

  const APP_VISUALS = '/assets/images/visuals'
  const DARK_MODE_CLASS = 'aw-2-dark'

  let isBrowserDarkMode

  try {
    isBrowserDarkMode = window.matchMedia && window.matchMedia('(prefers-color-scheme: dark)').matches
  } catch (_) {
    isBrowserDarkMode = false
  }

  const isDarkModeActive = darkMode === 'on' || (darkMode === 'auto' && isBrowserDarkMode)

  if (isDarkModeActive) {
    document.body.classList.add(DARK_MODE_CLASS)

    if (darkModeVariant) {
      document.body.classList.add(darkModeVariant)
    }
  }

  document.body.classList.add('aw-theme')

  /**
   * Selects startup assets before Angular renders the selected product.
   * @param {string} productId Selected product.
   */
  function applyProductBranding(productId) {
    const isaworkAI = productId === 'aworkAI'
    const prefix = isaworkAI ? 'logo-aworkAI' : 'logo'
    const logoWidth = isaworkAI ? (330 / 72) * 25 : 90
    const authLogoWidth = isaworkAI ? (330 / 72) * 56 : 203
    document.title = isaworkAI ? 'aworkAI' : 'awork'

    document.querySelectorAll('#loader-auth .logo img, #loader-framework img.logo').forEach(logoImg => {
      const isAuthLoaderLogo = Boolean(logoImg.closest('#loader-auth'))
      if (isAuthLoaderLogo) {
        const suffix = isDarkModeActive ? '-new-white.svg' : '-new.svg'
        logoImg.src = `${APP_VISUALS}/${prefix}${suffix}`
        logoImg.width = authLogoWidth
        logoImg.height = 56
        logoImg.style.width = `${authLogoWidth}px`
      } else {
        const suffix = isDarkModeActive ? '-white.svg' : '.svg'
        logoImg.src = `${APP_VISUALS}/${prefix}${suffix}`
        logoImg.width = logoWidth
        logoImg.height = 25
        logoImg.style.width = `${logoWidth}px`
      }
      logoImg.alt = isaworkAI ? 'aworkAI' : 'awork'
    })

    const authLink = document.querySelector('#loader-auth a.logo')
    if (authLink) {
      authLink.href = isaworkAI ? 'https://awork-ai.com' : 'https://www.awork.com'
    }

    const manifest = document.querySelector('link[rel="manifest"]')
    if (manifest) {
      manifest.href = isaworkAI ? '/manifest-aworkAI.webmanifest' : '/manifest.webmanifest'
    }

    if (isaworkAI) {
      document.querySelectorAll('link[rel="icon"]').forEach(icon => {
        icon.href = '/assets/icons/icon-aworkAI-96x96.png'
        icon.type = 'image/png'
        icon.setAttribute('sizes', '96x96')
      })
    }
  }

  const hostname = window.location.hostname
  const isaworkAI =
    (typeof LOCAL_PRODUCT_ID !== 'undefined' && LOCAL_PRODUCT_ID === 'aworkAI') ||
    ['bwork.io', 'awork-ai.com'].some(domain => hostname === domain || hostname.endsWith(`.${domain}`))
  applyProductBranding(isaworkAI ? 'aworkAI' : 'awork')

  const loader = document.getElementById(isLoggedIn ? 'loader-framework' : 'loader-auth')

  if (!menuPinned) {
    loader.classList.add('no-menu')
  } else {
    const menu = document.getElementById('menu')
    if (menu) {
      menu.classList.toggle('compact', menuCompact)

      if (menuCompact) {
        menu.style.width = '48px'
        menu.style.minWidth = '48px'
      } else {
        menu.style.width = `${menuWidth}px`
        menu.style.minWidth = ''
      }
    }
  }

  if (loader) {
    loader.style.display = 'block'
  }
})()
